import { Card } from 'types';
import styles from './../ContentStyles.module.css';
import classNames from 'classnames';
export interface TitleContentProps {
  content: Card;
}
export const TitleContent = ({
  content
}: TitleContentProps) => {
  const titleLength = content.title?.length || 0;
  const descriptionLength = content.description?.length || 0;
  const titleClasses = classNames({
    [styles.longTitle]: titleLength > 40
  });
  const descriptionClasses = classNames({
    [styles.longContent]: descriptionLength > 200
  });
  return <div className={styles.cardContent} data-sentry-component="TitleContent" data-sentry-source-file="TitleContent.tsx">
      <h1 className={titleClasses}>{content.title}</h1>
      <p className={descriptionClasses}>{content.description}</p>
    </div>;
};